import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface RedirectTarget {
  path: string;
  target: string;
}

const redirects: RedirectTarget[] = [
  { path: '/officehours', target: 'https://app.reclaim.ai/m/plotkin/nyu-office-hours' },
  { path: '/meet', target: 'https://app.reclaim.ai/m/plotkin/zoom' },
  { path: '/advising', target: 'https://app.reclaim.ai/m/plotkin/nyu-advising' }
];

export const Redirects: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;
    const redirect = redirects.find(r => r.path === currentPath);

    if (redirect) {
      window.location.href = redirect.target;
    }
  }, [location.pathname]);

  return null;
};

export default Redirects;